import { Skeleton } from '@/shared/components/skeleton';

import {
  FollowingRow,
  FollowingRows,
  FollowingSkeletonAction,
  FollowingSkeletonLogo,
  FollowingSkeletonMain,
  FollowingSkeletonText,
} from './following-list.styled';

const SKELETON_ROW_COUNT = 5;

export const FollowingListSkeleton = () => (
  <FollowingRows role="status" aria-label="Loading followed funds">
    {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
      <FollowingRow key={index}>
        <FollowingSkeletonMain>
          <FollowingSkeletonLogo>
            <Skeleton height={40} radius={8} />
          </FollowingSkeletonLogo>

          <FollowingSkeletonText>
            <Skeleton lineHeight={24} height={14} width="70%" />
            <Skeleton lineHeight={20} height={12} width="45%" />
          </FollowingSkeletonText>
        </FollowingSkeletonMain>

        <FollowingSkeletonAction>
          <Skeleton height={32} radius={8} />
        </FollowingSkeletonAction>
      </FollowingRow>
    ))}
  </FollowingRows>
);
